import {
  Box,
  Breakpoint,
  Button,
  CssBaseline,
  Grid,
  Typography,
} from "@mui/material";
import {
  AuthenticatedTemplate,
  MsalProvider,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { loginRequest } from "./config/authConfig";
import { useTranslation } from "react-i18next";
import { OrganizationProvider } from "./components/ContextProviders/OrganizationContext";
import { ApplicationProvider } from "./components/ContextProviders/ApplicationContext";
import { IPublicClientApplication } from "@azure/msal-browser";
import { LayoutSection } from "./components/Layout/LayoutSection";
import { HeaderSection } from "./components/Layout/HeaderSection";
import { NavDesktop } from "./components/Layout/NavSections";
import { MainLayout } from "./components/Layout/MainLayout";
import { Route, Routes } from "react-router-dom";
import SizeCalculators from "./components/SizeCalculatorsPage";
import ResetPasswordPage from "./components/MobileApp/ResetPasswordPage";
import LoginPage from "./components/LoginPage";
import { UnAuthenticatedRoutes } from "./components/Routes/UnAuthenticatedRoutes";
import AuthenticatedRouter from "./components/Routes/AuthenticatedRoutes";
import MobileRoutes from "./components/Routes/MobileRoutes";

type AppProps = {
  instance: IPublicClientApplication;
};
const layoutQuery: Breakpoint = "lg";

export default function App({ instance }: AppProps) {

  return (
    <MsalProvider instance={instance}>
      <ApplicationProvider>
        <OrganizationProvider>
          <>
            <CssBaseline />
            <Box sx={{ minHeight: "95vh" }}>
              {window.location.host.split(".")[0] == "mobileauth" ? (
                <MobileRoutes />
              ) : (
                <>
                  <UnauthenticatedTemplate>
                    <UnAuthenticatedRoutes />
                  </UnauthenticatedTemplate>
                  <AuthenticatedTemplate>
                    <LayoutSection
                      layoutQuery={layoutQuery}
                      headerSection={
                        <HeaderSection layoutQuery={layoutQuery} />
                      }
                      sidebarSection={<NavDesktop layoutQuery={layoutQuery} />}
                    >
                      <MainLayout layoutQuery={layoutQuery}>
                        <AuthenticatedRouter />
                      </MainLayout>
                    </LayoutSection>
                  </AuthenticatedTemplate>
                </>
              )}
            </Box>
          </>
        </OrganizationProvider>
      </ApplicationProvider>
    </MsalProvider>
  );
}
